/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { BillingSubscription } from "./BillingSubscription";
export const BillingSubscriptionResponse = core.serialization.object({
    data: BillingSubscription.optional(),
});
